var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"pa-3"},'v-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.beforeIcon)?_c('v-icon',{staticClass:"ml-0",attrs:{"left":""}},[_vm._v("mdi-"+_vm._s(_vm.beforeIcon))]):_vm._e(),_vm._t("default"),(_vm.afterIcon)?_c('v-icon',{staticClass:"mr-0",attrs:{"right":""}},[_vm._v("mdi-"+_vm._s(_vm.afterIcon))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }